module.exports = __webpack_public_path__ + "static/media/logo-ola-colorido.7670bbe4.svg";